
import {useEffect} from 'react';

import {State, useState} from './reducer';

export type EventVars = {
	region?: string
	slug?: string
	endDate?: string
	maxPages?: number
};

type _State = State & {
	loading: boolean
}

export const useEvents = (vars: EventVars): {
	state: _State,
	refresh: () => void,
} => {
	const [state, dispatch] = useState();

	// Always configure dispatch when state loads
	useEffect(() => {
		dispatch({type: 'SET-DISPATCH', dispatch});
	}, []);

	// If region changes, set on store & start query
	useEffect(() => {
		if (vars.region || vars.slug) {
			dispatch({type: 'SET-VARS', vars});
			dispatch({type: 'QUERY-START'});
		}
	}, [vars.region, vars.slug]);

	return {
		state: {
			...state,
			loading:
				state.token === '' ||
				state.inflight > 0 ||
				state.remaining.length > 0,
		},
		refresh: () => {
			dispatch({type: 'SET-VARS', vars});
			dispatch({type: 'QUERY-START'});
		},
	};
};
